import { gql } from "urql";

export const CREATE_NEW_CONTACT = gql`
  mutation createNewContact(
    $name: String!
    $service: String!
    $message: String!
    $mobile: Long!
    $email: String!
    $budget: String!
    $city: String!
    $location: String!
    $spaceType: String!
    $source_url: String!
  ) {
    createContactFormSubmission(
      data: {
        name: $name
        email: $email
        message: $message
        service: $service
        mobile: $mobile
        budget: $budget
        city: $city
        location: $location
        spaceType: $spaceType
        source_url: $source_url
      }
    ) {
      data {
        id
        attributes {
          name
          message
          service
          mobile
          email
          budget
          city
          location
          spaceType
          source_url
        }
      }
    }
  }
`;

//Name
//
